
<div class="container">
	<main [formGroup]="form">

		<p i18n class="error">Не удалось подключиться к SC-CryptoProxy на порт '{{port}}'.</p>
		<p i18n>Проверьте пожалуйста запущена ли программа или укажите другой порт</p>

		<div class="column">
			<label i18n class="required">Порт SC-CryptoProxy</label>
			<app-numberbox formControlName="portControl" name="Порт SC-CryptoProxy"></app-numberbox>
		</div>

	</main>

	<footer>
		<button i18n appSkin="action" (click)="enter()">Войти</button>
		<button i18n type="button" appSkin="simple no-shadow bold bordered" (click)="close()">Отмена</button>
	</footer>
</div>
